<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <div class="btn-group">
          <button
            type="button"
            id="btnTerug"
            class="btn btn-primary btn-xs"
            @click.prevent="btnTerug"
            v-if="this.$route.params.personid"
          >
            <font-awesome-icon icon="chevron-left" />
            {{ translation(14941) }}
          </button>
          <button type="button" id="btnToevoegen" class="btn btn-primary btn-xs" @click.prevent="btnToevoegen">
            <font-awesome-icon icon="plus" />
            {{ translation(14977) }}
          </button>
        </div>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(14953) }}</span>
      </div>
    </div>
    <div class="row" v-if="!this.$route.params.personid">
      <div class="col-md-12">
        <p v-html="translation(14954)"></p>
      </div>
    </div>
    <div class="row" v-if="this.$route.params.personid">
      <div class="col-md-12">
        <p v-html="translation(15187) + ' ' + myPersonData"></p>
      </div>
    </div>
    <div class="row checkboxclass margin20">
      <div class="col-md-12">
        <XVcheckbox
          style="margin: 7px"
          @click="
            AandeelhouderXVtablecolumnsettingchanged({
              column: 'tblVMSWAandeelhouderDatumInactief',
              visible: aandeelhoudersActive.toggle ? 0 : 1,
            })
          "
          v-model="aandeelhoudersActive.toggle"
          id="cbSelectAll"
        ></XVcheckbox>
        {{ translation(14955) }}
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <XVtableV2
          :tablesetting="aandeelhoudersTable.tablesetting"
          :tabledata="aandeelhoudersTable.tabledata"
          :rowvisible="aandeelhoudersTable.rowvisible"
          :tablecolumnsetting="aandeelhoudersTable.tablecolumnsetting"
          v-on:sortXVTable="AandeelhouderXVTablesort"
          :filterfunc="filterfunc"
          :XVtableSetRowStateProperty="AandeelhouderXVtableSetRowStateProperty"
          :chevronhiddenDesktop="false"
        >
          <template slot="tblVMSWAandeelhouderNaam" slot-scope="dr">
            <router-link
              v-if="!$route.params.personid"
              :to="{
                name: 'VMSWaandeelhoudersDetailUpdate',
                params: { aandeelhouderid: dr.row.tblVMSWAandeelhouderID },
              }"
              >{{ dr.row.tblVMSWAandeelhouderNaam }}</router-link
            >
            <router-link
              v-if="$route.params.personid"
              :to="{
                name: 'VMSWaandeelhoudersDetailUpdateInzien',
                params: { aandeelhouderid: dr.row.tblVMSWAandeelhouderID, personid: $route.params.personid },
              }"
              >{{ dr.row.tblVMSWAandeelhouderNaam }}</router-link
            >
          </template>
          <template slot="tblVMSWAandeelhouderAandelenPercentage" slot-scope="dr">
            <span>{{ dr.row.tblVMSWAandeelhouderAandelenPercentage | format2decimal }}</span>
          </template>
          <template slot="tblVMSWAandeelhouderStemrechtPercentage" slot-scope="dr">
            <span>{{ dr.row.tblVMSWAandeelhouderStemrechtPercentage | format2decimal }}</span>
          </template>
          <template slot="tblVMSWAandeelhouderAard" slot-scope="dr">
            <span v-if="dr.row.tblVMSWAandeelhouderAard === 1">{{ translation(14934) }}</span>
            <span v-if="dr.row.tblVMSWAandeelhouderAard === 2">{{ translation(14933) }}</span>
          </template>
          <template slot="tblVMSWAandeelhouderOpmerking" slot-scope="dr">
            <font-awesome-icon v-if="dr.row.tblVMSWAandeelhouderOpmerking !== null" :icon="['fal', 'comment-lines']" />
          </template>
          <template slot="tblVMSWAandeelhouderAandelenPercentage_detailrow" slot-scope="dr">
            <div class="row">
              <div :class="rowDetailHeaders">
                <label>{{ translation(14947) }}</label>
              </div>
              <div class="col-md-8 col-sm-8 col-xs-12 form-group">
                <span>{{ dr.row.tblVMSWAandeelhouderAandelenPercentage | format2decimal }}</span>
              </div>
            </div>
          </template>
          <template slot="tblVMSWAandeelhouderStemrechtPercentage_detailrow" slot-scope="dr">
            <div class="row">
              <div :class="rowDetailHeaders">
                <label>{{ translation(14948) }}</label>
              </div>
              <div class="col-md-8 col-sm-8 col-xs-12 form-group">
                <span>{{ dr.row.tblVMSWAandeelhouderStemrechtPercentage | format2decimal }}</span>
              </div>
            </div>
          </template>
          <template slot="detailrowbottom" slot-scope="dr" v-if="wLG === true || wXL === true">
            <div class="row">
              <div :class="rowDetailHeaders">
                <label>{{ translation(14929) }}</label>
              </div>
              <div class="col-md-8 col-sm-8 col-xs-12 form-group">{{ dr.row.tblVMSWAandeelhouderOpmerking }}</div>
            </div>
          </template>
        </XVtableV2>
      </div>
    </div>
  </div>
</template>
      
<script>
import { FAMixin } from 'pevueglobal'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { sync } from 'vuex-pathify'
export default {
  mixins: [FAMixin],
  data: function () {
    return {}
  },
  async created() {
    await this.getTextenAandeelhouders()
    if (this.$route.params.personid) {
      let personid = parseInt(this.$route.params.personid)
      await this.getAandeelhouders(personid)
    } else {
      await this.getAandeelhouders()
    }
    this.stopLoading()
  },
  computed: {
    ...mapGetters('VMSWbestuurdersAandeelhouders', ['aandeelhoudersTable', 'myPersonData']),
    aandeelhoudersActive: sync('VMSWbestuurdersAandeelhouders/aandeelhoudersActive'),
    visibleLG: function () {
      if (this.wLG || this.wXL) {
        return true
      } else {
        return false
      }
    },
    visibleMD: function () {
      if (this.wXS || this.wSM || this.wMD) {
        return true
      } else {
        return false
      }
    },
    visibleSM: function () {
      if (this.wXS || this.wSM) {
        return true
      } else {
        return false
      }
    },
    visibleXS: function () {
      if (this.wXS) {
        return true
      } else {
        return false
      }
    },
    rowDetailHeaders: function () {
      if (this.wXS || this.wSM) {
        return 'col-md-4 col-sm-4 col-xs-12'
      } else {
        return 'col-md-4 col-sm-4 col-xs-12 form-group'
      }
    },
  },
  methods: {
    ...mapActions('VMSWbestuurdersAandeelhouders', ['getAandeelhouders', 'getTextenAandeelhouders']),
    ...mapMutations('VMSWbestuurdersAandeelhouders', [
      'AandeelhouderXVTablesort',
      'AandeelhouderXVtablecolumnsettingchanged',
      'AandeelhouderXVtableSetRowStateProperty',
      'clearAandeelhouderDetail',
    ]),
    filterfunc: function (tabledata) {
      return tabledata.filter((n, index) => {
        if (this.aandeelhoudersActive.toggle) {
          return n.tblVMSWAandeelhouderDatumInactief === null
        } else {
          return true
        }
      })
    },
    btnTerug: function () {
      if (this.$route.params.personid) {
        window.location = '/beheer/SPE390_BH_Profs.aspx'
      }
    },
    btnToevoegen: function () {
      this.clearAandeelhouderDetail()
      if (this.$route.params.personid) {
        this.$router.push({ name: 'VMSWaandeelhoudersDetailInzien' })
      } else {
        this.$router.push({ name: 'VMSWaandeelhoudersDetail' })
      }
    },
    openComment: function (tablerow) {
      if (tablerow.row.tableRowState.rowVisible === false) {
        this.AandeelhouderXVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rowVisible',
          statePropertyValue: true,
        })
      } else {
        this.AandeelhouderXVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rowVisible',
          statePropertyValue: false,
        })
      }
    },
  },
}
</script>

<style>
</style>
      
